module.exports = __webpack_public_path__ + "static/bebauung5-64b0defeaae67dd47b0378fe34214eaf.png";